/**
 * @Author:
 * @Description:
 * @DateTime: Created in 08:23 2019-07-15
 */

import EnumItem, {enumMixn} from "./enumItem";

/**
 * 控制级别
 */
let EnumWaterLever = {
	One: 					new EnumItem('Ⅰ', 1),
	Two: 					new EnumItem('Ⅱ', 2),
	Three: 					new EnumItem('Ⅲ', 3),
	Four: 					new EnumItem('Ⅳ', 4),
	Five: 					new EnumItem('Ⅴ', 5),
	...enumMixn
}
export default EnumWaterLever
